var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.globalLoading && !_vm.hasError
        ? _c(
            "div",
            { staticClass: "el-section el-centered eu-align-items_center" },
            [
              _c("emd-pagarme-loader", {
                staticClass: "fade-in",
                attrs: { color: "secondary" },
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.globalLoading && _vm.hasError
        ? _c("global-error", {
            attrs: {
              showLogo: false,
              code: _vm.globalErrorCode,
              theme: _vm.theme,
            },
          })
        : !_vm.globalLoading && !_vm.hasError
        ? [_c("router-view")]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }